import Vue from "vue";
import VueCookies from "vue-cookies";
import Router from "vue-router";

import Index from "@/components/pages/index";
import Undervisning from "@/components/pages/undervisning/index";
import UndervisningDag1 from "@/components/pages/undervisning/dag-1";
import UndervisningDag2 from "@/components/pages/undervisning/dag-2";
import UndervisningDag3 from "@/components/pages/undervisning/dag-3";
import UndervisningDag4 from "@/components/pages/undervisning/dag-4";
import TilUnderviseren from "@/components/pages/til-underviseren";
import TipsOgTricks from "@/components/pages/tips-og-tricks/index";
import ScratchProjekter from "@/components/pages/tips-og-tricks/scratch-projekter";
import Scratch101 from "@/components/pages/tips-og-tricks/scratch-101";
import NyttigeLinks from "@/components/pages/tips-og-tricks/links";
import ScratchHelp from "@/components/pages/tips-og-tricks/scratch-help";
import Help from "@/components/pages/help/index";
import Tools from "@/components/pages/tools/index";
import Playground from "@/components/pages/playground";
import Faellesspil from "@/components/pages/faellesspil";
import Finale from "@/components/pages/finale/index";
import FinaleFinalister from "@/components/pages/finale/finalister";
import FinaleWorkshops from "@/components/pages/finale/workshops"
import FinaleInfo from "@/components/pages/finale/info"
import Skema from "@/components/pages/undervisning/skema";
import Links from "@/components/pages/links";
import Evaluering from "@/components/pages/evaluering";
import VideoTut from "@/components/pages/video-tutorials/index";
import VideoTutPlatformer from "@/components/pages/video-tutorials/video-tut-platformer";
import VideoTutScroller from "@/components/pages/video-tutorials/video-tut-scroller";
import VideoTutLabyrint from "@/components/pages/video-tutorials/video-tut-labyrint";
import VideoTutSkyde from "@/components/pages/video-tutorials/video-tut-skyde";
import Virksomhed from "@/components/pages/virksomhed";
import NextFinale from "@/components/pages/next-finale";
Vue.use(VueCookies);
Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "index",
      component: Index
    },
    {
      path: "/info-virksomhed",
      name: "virksomhed",
      component: Virksomhed
    },
    {
      path: "/tools",
      component: Tools
    },
    {
      path: "/playground",
      component: Playground
    },
    {
      path: "/faellesspil",
      component: Faellesspil
    },
    {
      path: "/finale",
      name: "finale",
      component: Finale,
      children: [
        {
          path: "finalister",
          component: FinaleFinalister
        },
        {
          path: "info",
          component: FinaleInfo
        },
        {
          path: "workshops",
          component: FinaleWorkshops
        }
      ]
    },
    {
      path: "/next-finale",
      name: "next-finale",
      component: NextFinale
    },
    {
      path: "/til-underviseren",
      component: TilUnderviseren
    },
    {
      path: "/online-undervisning",
      name: "undervisning",
      component: Undervisning,
      children: [
        {
          path: "dag-1",
          component: UndervisningDag1
        },
        {
          path: "dag-2",
          component: UndervisningDag2
        },
        {
          path: "dag-3",
          component: UndervisningDag3
        },
        {
          path: "dag-4",
          component: UndervisningDag4
        },
        {
          path: "skema/:version?",
          component: Skema
        }
      ]
    },
    {
      path: "/video-tutorials",
      name: "video-tutorials",
      component: VideoTut,
      children: [
        {
          path: "scroller",
          component: VideoTutScroller
        },
        {
          path: "platformer",
          component: VideoTutPlatformer
        },
        {
          path: "labyrint",
          component: VideoTutLabyrint
        },
        {
          path: "skyde",
          component: VideoTutSkyde
        }
      ]
    },
    {
      path: "/tips-og-tricks",
      name: "nyttige-links",
      component: TipsOgTricks,
      redirect: "/tips-og-tricks/scratch-101",
      children: [
        {
          path: "scratch-101",
          component: Scratch101
        },
        {
          path: "scratch-projekter",
          component: ScratchProjekter
        },
        {
          path: "links",
          component: NyttigeLinks
        },
        {
          path: "help",
          component: ScratchHelp
        }
      ]
    },
    {
      path: "/jens",
      name: "help-jens",
      component: Help
    },
    {
      path: "/mette",
      name: "help-mette",
      component: Help
    },
    {
      path: "/hjælp",
      name: "help",
      component: Help
    },
    {
      path: "/links",
      name: "links",
      component: Links
    },
    {
      path: "/evaluering",
      name: "evaluering",
      component: Evaluering
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js